<template>
  <div>
<xm-page class="order-confirm-page">
    <xm-page-content>
      <div>
        <div class="order-confirm">
          <div class="student">
            <div class="title"><span class="tip">*</span>学员</div>
            <div class="box-list">
              <div
                :class="['item', { 'active-item': selectedIndex === index }]"
                v-for="(item, index) in bindStudentList"
                :key="index"
                @click="changeStudent(index)"
              >
                <div :class="`${item.selectableStatus === 'AVAILABLE' ? '' : 'disable-item'}`">
                  <div class="name">{{ item.studentName }}</div>
                  <div class="phone">{{ item.phone }}</div>
                </div>
              </div>
              <div class="item add-item" @click="addStudent">
                <img src="../../images/mall/add.png" class="add-img" />
                <span class="text">添加学员</span>
              </div>
            </div>
          </div>
          <div class="pro-info">
            <div class="inst">
              <span class="icon iconfont">&#xe60c;</span>
              <span class="word">{{ inst.instName }}</span>
            </div>
            <div class="box">
              <div class="pro-img">
                <img v-if="productData.coverResource && productData.coverResource.resUrl" :src="productData.coverResource.resUrl" class="img" alt />
                <img v-else :src="goodsDefaultImg[productData.category]" class="img" alt />
              </div>
              <div class="detail">
                <div class="detail-title">
                  <span class="name">{{ productData.commodityAlias }}</span>
                  <div class="tag">
                    <span v-if="productData.category === 'COURSE'" class="item">课程</span>
                    <span v-if="productData.category === 'GOODS'" class="item">物品</span>
                    <span v-if="productData.category === 'FEE_ITEM'" class="item">费用</span>
                    <span v-if="productData.category === 'SUITE'" class="item">套餐</span>
                  </div>
                </div>
                <div class="goods-sku" v-if="productData.category === 'GOODS' && multiSpecification">
                  <span>{{ skuNames }}</span>
                </div>
                <div class="price" v-if="productData.category !== 'COURSE'">
                  <span class="value">¥{{ productData.commodityPrice }}</span>
                  <span class="unit" v-if="productData.category === 'GOODS'">/件</span>
                  <span class="unit" v-if="productData.category === 'FEE_ITEM'">/笔</span>
                  <!-- <span v-if="productData.category ==='SUITE'" class="line-price">¥{{productData.suiteOrgPrice}}</span> -->
                </div>
                <div class="price" v-else>
                  <span class="value">¥{{ slectCourse.totalPrice }}</span>
                  <span class="unit" v-if="slectCourse.feeType === 'CLASS_HOUR'">/{{ slectCourse.quantity }}课时</span>
                  <span class="unit" v-if="slectCourse.feeType === 'MONTH'">/{{ slectCourse.quantity }}个月</span>
                  <span class="unit" v-if="slectCourse.feeType === 'DAY'">/{{ slectCourse.quantity }}天</span>
                </div>
              </div>
            </div>
            <div v-if="productData.category === 'SUITE'" class="suite-label" @click="toggleSuite">
              套餐详情
              <span class="icon iconfont" style="vertical-align:middle;font-size:0.25rem;" v-if="!suiteShow">&#xe60e;</span>
              <span class="icon iconfont" style="vertical-align:bottom;font-size:0.25rem;" v-else>&#xe608;</span>
            </div>
            <div class="package" v-if="productData.category === 'SUITE' && suiteShow">
              <div class="item" v-for="(suiteItem, suiteIndex) in productData.suiteDetails" :key="suiteIndex">
                <div class="name">{{ suiteItem.commodityName }}</div>
                <div class="standard">
                  <span v-if="suiteItem.curSpec.commodityType === 'COURSE'"
                    >{{ suiteItem.curSpec.commoditySpecs.unitPrice }}元/{{ suiteItem.curSpec.commoditySpecs.containQuantity
                    }}{{ suiteItem.curSpec.commoditySpecs.measurementUnits }}</span
                  >
                  <span v-else-if="suiteItem.categoryType === 'GOODS' && suiteItem.goodsFeeItemInfo && suiteItem.goodsFeeItemInfo.multiSpecification">
                    <span>{{ suiteItem.curSpec.specName }}</span>
                    <span style="white-space:nowrap"
                      >({{ suiteItem.curSpec.commoditySpecs.unitPrice }}元/{{ suiteItem.curSpec.commoditySpecs.measurementUnits }})</span
                    >
                  </span>
                  <span v-else>{{ suiteItem.curSpec.commoditySpecs.unitPrice }}元/{{ suiteItem.curSpec.commoditySpecs.measurementUnits }}</span>
                </div>
                <div class="card">
                  <div class="buy">
                    <span>购买</span>
                    <span :style="{ color: suiteItem.error && suiteItem.categoryType === 'GOODS' ? 'red' : '' }">
                      <span>
                        <span v-if="suiteItem.curSpec.commodityType === 'COURSE' && suiteItem.curSpec.commoditySpecs.containQuantity > 1">{{
                          suiteItem.curSpec.commoditySpecs.containQuantity
                        }}</span>
                        <span v-else>{{ suiteItem.quantity }}</span>
                      </span>
                      <span v-if="suiteItem.unit === 'CLASS_HOUR'">课时</span>
                      <span v-if="suiteItem.unit === 'MONTH'">个月</span>
                      <span v-if="suiteItem.unit === 'DAY'">天</span>
                      <span v-if="suiteItem.unit === 'PIECE'">件</span>
                      <span v-if="suiteItem.unit === 'PACKET'">笔</span>
                    </span>
                  </div>
                  <div class="send" v-if="suiteItem.giftQuantity > 0">
                    <span>赠送</span>
                    <span>
                      {{ suiteItem.giftQuantity }}
                      <span v-if="suiteItem.giftUnit === 'CLASS_HOUR'">课时</span>
                      <span v-if="suiteItem.giftUnit === 'MONTH'">个月</span>
                      <span v-if="suiteItem.giftUnit === 'DAY'">天</span>
                      <span v-if="suiteItem.giftUnit === 'PIECE'">件</span>
                      <span v-if="suiteItem.giftUnit === 'PACKET'">笔</span>
                    </span>
                  </div>
                  <!-- 选择班级 -->
                  <div
                    class="select-class"
                    v-if="studentId && suiteItem.courseId && suiteItem.courseDetail && suiteItem.courseDetail.type === 'ONE2MANY' && showSettingsItem('_class_')"
                    @click="handleSuitItem(suiteItem.courseId, suiteIndex, suiteItem.classId)"
                  >
                    <span><span v-if="requiredSettingsItem('_class_')" class="tip">*</span>选择班级</span>
                    <div>
                      <span v-if="suiteItem.classId" class="selected_class_name" :style="{ color: suiteItem.error ? 'red' : '' }">{{
                        suiteItem.className
                      }}</span>
                      <span v-else class="gray">请选择</span>
                      <span class="icon iconfont">&#xe611;</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="total">
              <span class="num">共{{ purchaseNum }}件</span>
              <span class="value">小计：¥{{ productTotal }}</span>
            </div>
          </div>

          <div class="coupon-content" @click="handleShowChooseCoupon" v-if="productData.category === 'COURSE'">
            <div class="coupon-content-inner">
              <div class="coupon-content-text">使用优惠券</div>
              <div class="coupon-content-name gray" v-if="validCouponList.length == 0">暂无可用</div>
              <div class="coupon-content-name blue" v-if="validCouponList.length > 0 && !chooseCoupon.userCouponId">{{ validCouponList.length }}张可用</div>
              <div class="coupon-content-name normal" v-if="chooseCoupon.userCouponId">
                [
                <span class="coupon-content-name-title">{{ chooseCoupon.title }}</span>
                ] -￥{{ moneyFormatGroup(chooseCoupon.discountPrice, 2) }}
              </div>
              <span class="icon iconfont" v-if="validCouponList.length + invalidCouponList.length > 0">&#xe611;</span>
            </div>
          </div>
          <div v-if="showSettingsItem('_follower_')" class="setting-item" @click="handleShowPopup('_follower_')">
            <div class="content-inner">
              <div class="item-left"><span v-if="requiredSettingsItem('_follower_')" class="tip">*</span>课程顾问</div>
              <div class="item-right">
                <span v-if="selectedFollower.accountNo" class="select">{{
                  selectedFollower.nickName
                    ? selectedFollower.nickName
                    : desensitizeName(selectedFollower.adminName) + '(' + selectedFollower.accountNo.slice(7, 11) + ')'
                }}</span>
                <span v-else>请选择</span>
                <span class="icon iconfont">&#xe611;</span>
              </div>
            </div>
          </div>
          <div v-if="showSettingsItem('_manager_')" class="setting-item" @click="handleManagerClass()">
            <div class="content-inner">
              <div class="item-left"><span v-if="requiredSettingsItem('_manager_')" class="tip">*</span>学管师</div>
              <div class="item-right">
                <span v-if="selectedManager.accountNo" class="select">{{
                  selectedManager.nickName
                    ? selectedManager.nickName
                    : desensitizeName(selectedManager.adminName) + '(' + selectedManager.accountNo.slice(7, 11) + ')'
                }}</span>
                <span v-else>请选择</span>
                <span class="icon iconfont">&#xe611;</span>
              </div>
            </div>
          </div>
          <div v-if="showSelectClassForm && studentId && showSettingsItem('_class_')" class="cell-content" @click="handleShowClass()">
            <div class="cell-content-inner">
              <div class="cell-content-text"><span v-if="requiredSettingsItem('_class_')" class="tip">*</span>选择班级</div>
              <div v-if="selectedClass.classId" class="cell-content-name">{{ selectedClass.className }}</div>
              <div v-else class="cell-content-name gray">请选择</div>
              <span class="icon iconfont">&#xe611;</span>
            </div>
          </div>
          <div v-if="showSettingsItem('_gender_')" class="cell-content" @click="handleShowPopup('_gender_')">
            <div class="cell-content-inner">
              <div class="cell-content-text"><span v-if="requiredSettingsItem('_gender_')" class="tip">*</span>性别</div>
              <div class="cell-content-name gray">
                <span v-if="!currentGender">请选择</span>
                <span style="color:#333;" v-else>{{ currentGender.value }}</span>
              </div>
              <span class="icon iconfont">&#xe611;</span>
            </div>
          </div>
          <div v-if="showSettingsItem('_birthday_')" class="cell-content" @click="handleShowPopup('_birthday_')">
            <div class="cell-content-inner">
              <div class="cell-content-text"><span v-if="requiredSettingsItem('_birthday_')" class="tip">*</span>生日</div>
              <div class="cell-content-name gray">
                <span v-if="!currentDate">请选择</span>
                <span style="color:#333;" v-if="currentDate">{{
                  new Date(currentDate).getFullYear() + `年` + (new Date(currentDate).getMonth() + 1) + '月' + new Date(currentDate).getDate() + '日'
                }}</span>
              </div>
              <span class="icon iconfont">&#xe611;</span>
            </div>
          </div>
          <div v-if="showSettingsItem('_school_')" class="cell-content" @click="handleShowPopup('_school_')">
            <div class="cell-content-inner">
              <div class="cell-content-text"><span v-if="requiredSettingsItem('_school_')" class="tip">*</span>就读学校</div>
              <van-field v-model="currentSchool" placeholder="请输入" maxlength="50" input-align="right" style="max-width:4rem;margin-right: 0.08rem" />
            </div>
          </div>
          <div v-if="showSettingsItem('_grade_')" class="cell-content" @click="handleShowPopup('_grade_')">
            <div class="cell-content-inner">
              <div class="cell-content-text"><span v-if="requiredSettingsItem('_grade_')" class="tip">*</span>当前年级</div>
              <div class="cell-content-name gray">
                <span v-if="!currentGrade">请选择</span>
                <span style="color:#333;" v-if="currentGrade">{{ currentGrade.name }}</span>
              </div>
              <span class="icon iconfont">&#xe611;</span>
            </div>
          </div>
          <div v-for="(item, index) in studentAttributes" :key="index">
            <div v-if="showSettingsItem(item.attrId) && item.attrType === 'SINGLE_OPTION'" class="cell-content" @click="openCustomPopup(item, index)">
              <div class="cell-content-inner">
                <div class="cell-content-text"><span v-if="requiredSettingsItem(item.attrId)" class="tip">*</span>{{ item.attrName }}</div>
                <div class="cell-content-name gray">
                  <span style="color:#333;" v-if="item.optionId > 0">{{ item.optionName }}</span>
                  <span v-else>请选择</span>
                </div>
                <span class="icon iconfont">&#xe611;</span>
              </div>
            </div>
            <div v-if="showSettingsItem(item.attrId) && item.attrType === 'TEXT'" class="cell-content">
              <div class="cell-content-inner">
                <div class="cell-content-text"><span v-if="requiredSettingsItem(item.attrId)" class="tip">*</span>{{ item.attrName }}</div>
                <van-field v-model="item.attrText" placeholder="请输入" maxlength="50" input-align="right" style="max-width:4rem;margin-right: 0.08rem" />
              </div>
            </div>
          </div>
          <div v-if="showSettingsItem('_memo_')" class="description" @click="handleShowPopup('_memo_')">
            <div class="label"><span v-if="requiredSettingsItem('_memo_')" class="tip">*</span>留言</div>
            <textarea
              name
              id="remark"
              cols="30"
              rows="10"
              maxlength="100"
              placeholder="对课程、老师等有任何要求都可以留言，我们会尽力满足您的要求～"
              v-model="memo"
              v-on:blur="inputBlur"
            ></textarea>
          </div>
        </div>
        <div class="footer">
          <div class="text">
            <span class="text-left">合计：¥{{ moneyFormatGroup(productTotal - (chooseCoupon.discountPrice || 0), 2) }}</span>
            <span class="text-right" v-if="chooseCoupon.discountPrice">¥{{ moneyFormatGroup(productTotal, 2) }}</span>
          </div>
          <div class="submit" @click="submitOrder">付款</div>
        </div>
      </div>
      <mt-popup v-model="showChooseCoupon" class="coupon-popup" position="bottom">
        <ChooseCoupon
          :visible="showChooseCoupon"
          :validCouponList="validCouponList"
          :invalidCouponList="invalidCouponList"
          :chooseCoupon="chooseCoupon"
          @chooseEvent="handleChooseCoupon"
          @hideChooseCoupon="hideChooseCoupon"
        ></ChooseCoupon>
      </mt-popup>
      <yd-popup v-model="showAddClass" position="bottom" height="90%">
        <AddClass
          :studentId="studentId"
          :courseId="courseId"
          :classId="selectedClass.classId"
          :require="requiredSettingsItem('_class_') ? 'require' : ''"
          @cancel="closeAddClass"
          @confirm="confirmAddClass"
          v-if="showAddClass"
        ></AddClass>
      </yd-popup>
      <!-- 学管师 -->
      <yd-popup v-if="showAddManager" v-model="showAddManager" class="manager-popup" position="bottom" height="90%">
        <AddManager :managerId="selectedManager.id || ''" @cancel="closeAddManager" @confirm="confirmAddManager" ></AddManager>
      </yd-popup>
      <!-- 跟进人 -->
      <yd-popup v-if="showAddFollower" v-model="showAddFollower" class="follower-popup" position="bottom" height="90%">
        <AddFollower :managerId="selectedFollower.id || ''" @cancel="closeAddFollower" @confirm="confirmAddFollower" ></AddFollower>
      </yd-popup>
      <mt-popup v-model="showAddStudent" class="student-popup" position="bottom">
        <AddStudent :instId="instId" :addNewStudent="addNewStudent" :hideAddStudentPop="hideAddStudentPop" v-if="showAddStudent"></AddStudent>
      </mt-popup>
      
      <!-- 性别 -->
      <wheat-popup v-model="showGenderPopup" :customStyle="customStyle" :zIndex="11111">
        <wheat-picker
          :showToolbar="true"
          :slots="genderSlots"
          :visibleItemCount="5"
          @change="
            (picker, value) => {
              handleChangeSlotValues(picker, value, '_gender_');
            }
          "
        >
          <div class="toolbar">
            <span class="toolbar-cancle" @click="handleShowPopup('_gender_')">取消</span>
            <span class="toolbar-ok" @click="handleOkSelect('_gender_')">完成</span>
          </div>
        </wheat-picker>
      </wheat-popup>
      <!-- 当前年级 -->
      <wheat-popup v-model="showGradePopup" :customStyle="customStyle" :zIndex="11111">
        <wheat-picker
          :showToolbar="true"
          :slots="gradeSlots"
          :visibleItemCount="5"
          @change="
            (picker, value) => {
              handleChangeSlotValues(picker, value, '_grade_');
            }
          "
        >
          <div class="toolbar">
            <span class="toolbar-cancle" @click="handleShowPopup('_grade_')">取消</span>
            <span class="toolbar-ok" @click="handleOkSelect('_grade_')">完成</span>
          </div>
        </wheat-picker>
      </wheat-popup>
      <!-- 自定义 -->
      <wheat-popup v-model="showCustomPopup" :customStyle="customStyle" :zIndex="11111">
        <wheat-picker
          :showToolbar="true"
          :slots="customSlots"
          :visibleItemCount="5"
          @change="
            (picker, value) => {
              handleChangeSlotValues(picker, value, '_custom_');
            }
          "
        >
          <div class="toolbar">
            <span class="toolbar-cancle" @click="closeCustomPopup()">取消</span>
            <span class="toolbar-ok" @click="handleOkCustomSelect()">完成</span>
          </div>
        </wheat-picker>
      </wheat-popup>
    </xm-page-content>
  </xm-page>
  <!-- 生日 -->
      <wheat-popup v-model="showDatePopup" :customStyle="customStyle" :zIndex="11111">
        <van-datetime-picker
          @cancel="handleShowPopup('_birthday_')"
          @confirm="handleDateOkSelect"
          v-model="dateChooseValues"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
        />
      </wheat-popup>
  </div>
  
</template>
<script>
import User from '@/core/user';
import UserService from '@/service/UserService';
import InstService from '../../service/InstitutionService';
import PayService from '@/service/PayService';
import Platform from '@/core/platform';
import LoginService from '@/service/LoginService';
import ChooseCoupon from './ChooseCouponV5';
import AddClass from './AddClass';
import AddStudent from './AddStudent';
import AddManager from './AddManager';
import AddFollower from './AddFollower';
import { moneyFormatGroup } from '../../core/filters';
import { CheckSpecEnum, CategoryUnitEnum } from '@/enum/MallEnum';
import { Toast } from 'vant';
export default {
  components: {
    ChooseCoupon,
    AddClass,
    AddStudent,
    AddManager,
    AddFollower,
  },
  computed: {
    studentId: function() {
      if (this.bindStudentList.length && this.selectedIndex !== -1) {
        return this.bindStudentList[this.selectedIndex].studentId;
      }
      return '';
    },
  },
  data() {
    return {
      test:false, 
      productData: {},
      inst: {},
      instId: window.getParameterByName('instId'),
      selectedIndex: -1,
      bindStudentList: [],
      memo: '',
      payStatus: 1,
      payType: 4,
      validCouponList: [], // 可使用的优惠券
      invalidCouponList: [], // 不可用的优惠券
      chooseCoupon: {}, // 选择的优惠券
      showChooseCoupon: false,
      showAddStudent: false,
      showAddClass: false, // 选择班级
      showAddManager: false, // 选择学管师
      showAddFollower: false, // 选择跟进人
      showSelectClassForm: false, // 是否显示【选择班级】的表单项
      selectedClass: {},
      selectedManager: {},
      selectedManagerId: '',
      selectedFollowerId: '',
      selectedFollower: {},
      courseId: '',
      managerId: '',
      slectCourse: '',
      objectId: randomString(32),
      purchaseNum: window.getParameterByName('purchaseNum') || 1,
      productTotal: 0,
      moneyFormatGroup,
      adviserList: [],
      adviserChooseValues: [],
      customStyle: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
      },
      adviserSlots: [],
      voucherId: '',
      suiteShow: true,
      userPhone: '',
      skuNames: '',
      multiSpecification: false,
      addedStudent: {}, // 【添加学员】添加的学员
      settings: [], // 商城固定配置
      studentAttributes: [], // 自定义学员信息
      currentAdviser: '',
      followerList: [],
      managerList: [],
      gradeList: [],
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(),
      showGradePopup: false,
      showGenderPopup: false,
      showCustomPopup: false,
      showDatePopup: false,
      currentSchool: '',
      currentGender: '',
      currentGrade: {},
      currentDate: '',
      followerSlots: [],
      gradeSlots: [],
      genderSlots: [
        {
          values: [
            { code: 1, name: 'MAN', value: '男' },
            { code: 2, name: 'WOMEN', value: '女' },
          ],
          defaultIndex: 0,
        },
      ],
      customSlots: [],
      followerChooseValues: {},
      genderChooseValues: {},
      gradeChooseValues: {},
      customChooseValues: [],
      dateChooseValues: '',
      customIndex: 0,
      class: '',
      goodsDefaultImg: {
        COURSE: 'https://image.xiaomaiketang.com/xm/internal/eMdhFaJ3NF.png',
        GOODS: 'https://image.xiaomaiketang.com/xm/internal/BebQYQSnHz.png',
        FEE_ITEM: 'https://image.xiaomaiketang.com/xm/internal/BGDFZxjSzk.png',
        SUITE: 'https://image.xiaomaiketang.com/xm/internal/3XhA6MQnSG.png',
      },
      supportAssetsPay: false // 是否支持帐户支付
    };
  },
  beforeCreate() {
    console.log('beforeCreate---页面刷新');
  },
  beforeRouteEnter(to, from, next) {
    console.log('路由进入');
    if (from.name === 'online_relevance') {
      if (from.params.action === 'create') {
        next(vm => {
          vm.showAddStudent = true;
        });
      } else if (from.params.action === 'add') {
        next(vm => {
          vm.addRelevanceStudent(from.params.studentArr);
        });
      }
    } else {
      next();
    }
  },
  created() {
    this.fetchProductDetail();
    this.fetchSettings();
    this.getGradeList();
    this.fetchFollowerList();
    this.fetchManagerList();
    this.checkSupportAssetsPay();
  },
  mounted() {
    wx.hideMenuItems({
      menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'], // 要显示的菜单项，所有menu项见附录3
    });
    if (window.location.href.indexOf('fromBrandMiniapp') != -1 || window.localStorage.getItem('fromBrandMiniapp')) {
      this.wxMiNiProgramReady();
    }
    this.userPhone = window.userConfig.bindPhone;
    // this.getAdviserList();
    this.fetchInstData();

    this.payType = Platform.isWeiXin() ? 4 : 3;
    this.openId = window.localStorage.getItem('pay_openId');
    PayService.getAppid(this.payType).then(res => {
      this.appid = res.result;
      this.preparePay();
    });
  },
  destroyed() {
    wx.hideMenuItems({
      menuList: ['menuItem:copyUrl'], // 要显示的菜单项，所有menu项见附录3
    });
  },
  methods: {
    preparePay() {
      const code = window.getParameterByName('code');
      if (Platform.isAlipay()) {
        if (!window.getParameterByName('auth_code')) {
          const url = window.location.href;
          const reloadUrl = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${
            this.appid
          }&scope=auth_base&redirect_uri=${window.encodeURIComponent(url)}`;
          location.replace(reloadUrl);
          // this.getPayDetail(); // 为了兼容不刷新的安卓
        }
      } else {
        if (!code) {
          let url = location.href;
          const reloadUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${window.encodeURIComponent(
            url,
          )}&response_type=code&scope=snsapi_base#wechat_redirect`;
          location.replace(reloadUrl);
        } else {
          if (!this.openId) {
            this.autoLogin();
          }
        }
      }

      // 确认订单-PC端调试
      // if (Platform.isAlipay()) {
      //   if (!window.getParameterByName('auth_code')) {
      //     const url = window.location.href;
      //     const reloadUrl = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${
      //       this.appid
      //     }&scope=auth_base&redirect_uri=${window.encodeURIComponent(url)}`;
      //     location.replace(reloadUrl);
      //     // this.getPayDetail(); // 为了兼容不刷新的安卓
      //   } else {
      //     if (code) {
      //       if (!this.openId) {
      //         this.autoLogin();
      //       }
      //     }
      //   }
      // }
    },
    autoLogin() {
      const code = window.getParameterByName('code');
      LoginService.autoLogin(code, this.appid, window.encryptCode()).then(res => {
        this.openId = res.result;
        window.localStorage.setItem('pay_openId', res.result);
      });
    },
    // 获取商品详情
    fetchProductDetail() {
      const data = {
        commodityId: window.getParameterByName('commodityId'),
        instId: window.getParameterByName('instId'),
      };
      var that = this;
      axios.Customer('anon/mall/getCommodityDetail', data).then(res => {
        if (res.success) {
          console.log('商品详情', res.result);
          that.productData = res.result;
          if (res.result.category === 'COURSE') {
            if (res.result.courseType === 'ONE2MANY') {
              this.showSelectClassForm = true;
            }
            this.courseId = res.result.courseId;
            for (var i = 0; i < res.result.coursePrices.length; i++) {
              if (res.result.coursePrices[i].specId == window.getParameterByName('specId')) {
                that.slectCourse = res.result.coursePrices[i];
                that.productTotal = res.result.coursePrices[i].totalPrice;
              }
            }
          } else {
            if (res.result.category === 'GOODS') {
              this.multiSpecification = res.result.goodsInfo && res.result.goodsInfo.multiSpecification;
            }
            if (res.result.category === 'GOODS' && res.result.goodsInfo && res.result.goodsInfo.multiSpecification) {
              const _skuNames = [];
              const _sku = _.find(res.result.goodsInfo.goodsSku.skuItems, i => i.specId === window.getParameterByName('specId'));
              const _skuItemInfo = _sku.skuItemInfo;
              _.each(res.result.goodsInfo.goodsSku.skuAttrs, j => {
                _skuNames.push(_skuItemInfo[j.attrName]);
              });
              this.skuNames = _skuNames.join('；');
            }
            this.initSuiteGoodsSkuBySpecid(res);
            that.productTotal = res.result.commodityPrice * this.purchaseNum;
          }
          if (User.token()) {
            this.getBindStudentList();
          }
        }
      });
    },
    // 获取关联学生列表
    getBindStudentList(flag = true) {
      const appId = User.appId();
      const platform = Platform.isWeiXin() ? 'WECHAT_GZH' : 'ALIYUN_H5';
      const commodityId = window.getParameterByName('commodityId');
      let that = this;
      return UserService.getReletedStundentList(appId, platform, commodityId).then(res => {
        console.log('关联学生', res);
        if (res.success) {
          this.bindStudentList = res.result;
          for (let i = 0; i < res.result.length; i++) {
            if (this.bindStudentList[i] && this.bindStudentList[i].selectableStatus === 'AVAILABLE') {
              this.selectedIndex = i;
              break;
            }
          }
          if (this.selectedIndex !== -1) {
            this.getStuInfo(this.studentId);
          }
        }
        if (this.productData.category === 'COURSE'&& flag) {
          console.log('getBind');
          this.fetchCouponLIst();
        }
      });
    },
    formDate(data, format) {
      // console.log("data,time");
      let time = {
        "M+": data.getMonth() + 1,
        "D+": data.getDate(),
        "H+": data.getHours(),
        "m+": data.getMinutes(),
        "s+": data.getSeconds(),
      };

      if (/(y+)/i.test(format)) {
        format = format.replace(
          RegExp.$1,
          (data.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (let k in time) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? time[k]
              : ("00" + time[k]).substr(("" + time[k]).length)
          );
        }
      }
      return format;
    },
    // 添加新学员
    async addNewStudent(student) {
      if (User.token() && student._type !== 'select') {
        this.addedStudent = student;
        await this.getBindStudentList(false);

        if (this.bindStudentList[this.bindStudentList.length - 1] && this.bindStudentList[this.bindStudentList.length - 1].selectableStatus === 'AVAILABLE') {
          this.selectedIndex = this.bindStudentList.length - 1;
          this.currentDate = '';
          this.currentGrade = {};
          this.currentGender = '';
          this.selectedClass = {};
          this.selectedManager = {};
          this.selectedFollower = {};
          this.getStuInfo(this.studentId);
        }
      } else {
        this.bindStudentList.push(student);
        this.selectedIndex = this.bindStudentList.length - 1;
        this.currentDate = '';
        this.currentGrade = {};
        this.currentGender = '';
        this.chooseCoupon = {};
        this.selectedClass = {};
        this.selectedManager = {};
        this.selectedFollower = {};
        this.getStuInfo(this.studentId);
      }
      this.showAddStudent = false;
      if (this.productData.category === 'COURSE') {
        console.log('addNew');
        this.fetchCouponLIst();
      }
    },
    addRelevanceStudent(studentArr) {
      this.addedStudent = studentArr[0];
    },

    initSuiteGoodsSkuBySpecid(res) {
      const isMultiSpecification = _.some(
        res.result.suiteDetails,
        suiteItem => suiteItem.categoryType === 'GOODS' && suiteItem.goodsFeeItemInfo && suiteItem.goodsFeeItemInfo.multiSpecification,
      );
      if (res.result.category === 'SUITE' && isMultiSpecification) {
        const specIdStr = window.sessionStorage.getItem(`suite_${res.result.id}`) || '{}';
        const _specId = JSON.parse(specIdStr);
        _.each(res.result.suiteDetails, suiteItem => {
          if (_specId[suiteItem.commodityId]) {
            const specId = _specId[suiteItem.commodityId];
            const specItem = _.find(suiteItem.specs, i => i.id === specId);
            if (specItem) {
              suiteItem.curSpec = specItem;
              suiteItem.specId = specId;
            }
          }
        });
      }
    },
    fetchInstData() {
      const id = window.getParameterByName('instId');
      InstService.getInstMicroSiteInfo(id)
        .then(res => {
          this.inst = res.result;
        })
        .catch(error => {})
        .finally(() => {
          // window.hideLoading();
        });
    },
    // 切换学生
    changeStudent(index) {
      if (this.bindStudentList[index].selectableStatus === 'AVAILABLE') {
        this.selectedIndex = index;
        if (this.productData.category === 'COURSE') {
          this.fetchCouponLIst();
        }
        if (this.productData.category === 'SUITE') {
          this.productData.suiteDetails.map(item => {
            Object.assign(item, {
              classId: '',
              className: '',
            });
          });
        } else {
          this.selectedClass = {};
        }
        this.currentDate = '';
        this.currentGrade = {};
        this.currentGender = '';
        this.selectedManager = {};
        this.selectedFollower = {};
        this.getStuInfo(this.studentId);
      } else if (this.bindStudentList[index].selectableStatus === 'ONLY_NORMAL_STUDENT') {
        Vue.$wheatToast({
          message: '该商品仅支持在读学员购买',
          position: 'middle',
          duration: 1000,
        });
      } else if (this.bindStudentList[index].selectableStatus === 'EXCEPT_NORMAL_STUDENT') {
        Vue.$wheatToast({
          message: '该商品不支持在读学员购买',
          position: 'middle',
          duration: 1000,
        });
      } else if (this.bindStudentList[index].selectableStatus === 'PURCHASE_NUMBER_RESTRICTED') {
        Vue.$wheatToast({
          message: `该商品每人只可购买${this.productData.purchaseNumberRestriction}个`,
          position: 'middle',
          duration: 1000,
          width: 200,
        });
      }
    },
    getCheckPurchaseItemParams() {
      let orderDetails;
      const instId = this.instId;
      const studentId = this.studentId;

      if (this.productData.category === 'SUITE') {
        orderDetails = this.productData.suiteDetails.map(item => {
          const { classId, quantity, giftQuantity, giftUnit, categoryType, specId, unit } = item;

          return {
            classId,
            purchaseItemType: categoryType === 'COURSE' ? 'COURSE' : categoryType === 'GOODS' ? 'ARTICLE' : 'FEE',
            purchaseQuantity: quantity,
            giftNum: giftQuantity,
            giftUnit,
            specId,
            suiteCommodityId: this.productData.id,
            unit,
          };
        });
      } else {
        const { category, id, coursePrices } = this.productData;
        let unit;
        let classId;

        if (category === 'COURSE') {
          classId = this.selectedClass.classId;
          unit = coursePrices[this.selectCourseIndex || 0].feeType;
        } else {
          unit = CategoryUnitEnum[category].unit;
        }

        orderDetails = Array.of({
          classId,
          purchaseItemType: category === 'COURSE' ? 'COURSE' : category === 'GOODS' ? 'ARTICLE' : 'FEE',
          purchaseQuantity: this.purchaseNum,
          specId: window.getParameterByName('specId'),
          suiteCommodityId: id,
          unit,
        });
      }

      return {
        instId,
        orderDetails,
        studentId,
      };
    },
    getFormatDate() {
    var date = new Date();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    month = (month<10)? '0'+ month : month;
    day = (day<10)? '0'+ day : day;
    hour = (hour<10)? '0'+ hour : hour;
    minutes = (minutes<10)? '0'+ minutes : minutes;
    seconds = (seconds<10)? '0'+ seconds : seconds;
    var currentDate = date.getFullYear() + "-" + month + "-" + day
            + " " + hour + ":" + minutes + ":" + seconds;
    return currentDate;
},
    // 校验提示
    renderCheckTips(specArr) {
      const suiteDetails = JSON.parse(JSON.stringify(this.productData.suiteDetails));

      if (suiteDetails.length) {
        suiteDetails.map(suite => {
          suite.error = false;
          specArr.map(spec => {
            if (suite.specId === spec) {
              suite.error = true;
            }
          });
        });
        this.productData.suiteDetails = suiteDetails;
      }
    },
    // 校验创建订单
    checkPurchaseItem() {
      const params = this.getCheckPurchaseItemParams();
      return axios.Customer('anon/order/checkPurchaseItem', params);
    },
    // 提交
    async submitOrder() {
      if (this.submiting) {
        return;
      }
      this.submiting = true;
      setTimeout(() => {
        this.submiting = false;
      }, 2000);
      if (!this.studentId) {
        Vue.$wheatToast({
          message: '请选择学员',
          position: 'middle',
          duration: 1000,
        });
        return;
      }
      if (this.bindStudentList.length == 0) {
        Vue.$wheatToast({
          message: '请添加学员',
          position: 'middle',
        });
        return;
      }
      const code = window.getParameterByName('code');
      const authCode = window.getParameterByName('auth_code');

      let businessOwners;
      if (!this.currentAdviser.id) {
        businessOwners = [];
      } else {
        businessOwners = [this.currentAdviser.id];
      }
      let orderDetails;

      if (this.productData.category === 'SUITE') {
        orderDetails = this.productData.suiteDetails.map(item => {
          const { classId, quantity, giftQuantity, giftUnit, categoryType, specId, unit,courseDetail } = item;
          return {
            classId,
            purchaseItemType: categoryType === 'COURSE' ? 'COURSE' : categoryType === 'GOODS' ? 'ARTICLE' : 'FEE',
            purchaseQuantity: quantity,
            giftNum: giftQuantity,
            giftUnit,
            specId,
            suiteCommodityId: this.productData.id,
            unit,
            type: categoryType === 'COURSE' ?courseDetail.type:''
          };
        });
      } else {
        const { category, coursePrices } = this.productData;
        let unit;
        let classId;

        if (category === 'COURSE') {
          classId = this.selectedClass.classId;
          unit = this.slectCourse.feeType;
        } else {
          unit = CategoryUnitEnum[category].unit;
        }

        orderDetails = Array.of({
          classId,
          purchaseItemType: category === 'COURSE' ? 'COURSE' : category === 'GOODS' ? 'ARTICLE' : 'FEE',
          purchaseQuantity: this.purchaseNum,
          specId: window.getParameterByName('specId'),
          unit,
        });
      }
      const data = {
        businessOwners: businessOwners,
        memo: this.memo,
        objectId: this.objectId,
        orderDetails,
        studentId: this.studentId,
        userId: User.uid(),
        entrance: window.getParameterByName('fromShare')==='true' ? 'LINK' : 'APP',
        commodityId: this.productData.id,
      };
      let that = this;
      if (this.chooseCoupon.userCouponId) {
        data.orderPromotion = {
          userCouponId: this.chooseCoupon.userCouponId,
        };
      }
      // 处理套餐中课程的选必填
      let requireClass = 0;
      console.log('orderDetails',orderDetails);
      for (let k = 0; k < orderDetails.length; k++){
        if(this.requiredSettingsItem('_class_') && orderDetails[k].purchaseItemType==="COURSE" && !orderDetails[k].classId && orderDetails[k].type==="ONE2MANY"){
          requireClass++;
        }
      }

      if (this.productData.category === 'SUITE' && requireClass > 0) {
         Vue.$wheatToast({
          message: '请选择班级',
          position: 'middle',
          duration: 1000,
        });
        return;
      }
      if (this.requiredSettingsItem('_follower_') && !this.selectedFollower.id) {
        Vue.$wheatToast({
          message: '请选择课程顾问',
          position: 'middle',
          duration: 1000,
        });
        return;
      } else if (this.requiredSettingsItem('_manager_') && !this.selectedManager.id) {
        Vue.$wheatToast({
          message: '请选择学管师',
          position: 'middle',
          duration: 1000,
        });
        return;
      } else if (this.requiredSettingsItem('_class_') && this.showSelectClassForm && !this.selectedClass.classId) {
        Vue.$wheatToast({
          message: '请选择班级',
          position: 'middle',
          duration: 1000,
        });
        return;
      } else if (this.requiredSettingsItem('_gender_') && !this.currentGender) {
        Vue.$wheatToast({
          message: '请选择性别',
          position: 'middle',
          duration: 1000,
        });
        return;
      } else if (this.requiredSettingsItem('_birthday_') && !this.currentDate) {
        Vue.$wheatToast({
          message: '请选择生日',
          position: 'middle',
          duration: 1000,
        });
        return;
      } else if (this.requiredSettingsItem('_school_') && !this.currentSchool) {
        Vue.$wheatToast({
          message: '请输入就读学校',
          position: 'middle',
          duration: 1000,
        });
        return;
      } else if (this.requiredSettingsItem('_grade_') && !this.currentGrade) {
        Vue.$wheatToast({
          message: '请选择当前年级',
          position: 'middle',
          duration: 1000,
        });
        return;
      } else if (this.requiredSettingsItem('_memo_') && !this.memo) {
        Vue.$wheatToast({
          message: '请选择留言',
          position: 'middle',
          duration: 1000,
        });
        return;
      }
      for (let i = 0; i < this.studentAttributes.length; i++) {
        if (
          this.studentAttributes[i].attrType === 'SINGLE_OPTION' &&
          this.requiredSettingsItem(this.studentAttributes[i].attrId) &&
          !this.studentAttributes[i].optionId
        ) {
          Vue.$wheatToast({
            message: '请选择' + this.studentAttributes[i].attrName,
            position: 'middle',
            duration: 1000,
          });
          return;
        } else if (
          this.studentAttributes[i].attrType === 'TEXT' &&
          this.requiredSettingsItem(this.studentAttributes[i].attrId) &&
          !this.studentAttributes[i].attrText
        ) {
          Vue.$wheatToast({
            message: '请输入' + this.studentAttributes[i].attrName,
            position: 'middle',
            duration: 1000,
          });
          return;
        }
      }
      data.orderFormData = {
        attributes: this.studentAttributes,
        birthday: this.currentDate,
        followerId: this.selectedFollower.id,
        managerId: this.selectedManager.id,
        school: this.currentSchool,
      };

      if (this.currentGender.name) {
        data.orderFormData.gender = this.currentGender.name;
      }

      if (this.currentGrade) {
        data.orderFormData.grade = this.currentGrade.code;
      }

      // const checkRes = await this.checkPurchaseItem();
      const params = this.getCheckPurchaseItemParams();
      axios.Customer('anon/order/checkPurchaseItem', params).then(checkRes => {
        const { checkPass, checkSpecIdsMap } = checkRes.result;
        const { category } = this.productData;
        console.log(checkPass,'checkPass');
        if (!checkPass) {
          for (let item of Object.entries(checkSpecIdsMap)) {
            if (category === 'SUITE') {
              this.renderCheckTips(item[1]);
            }
            Vue.$wheatToast(CheckSpecEnum[item[0]].describe);
            return;
          }
        } else {
          Toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0,
          });
          console.log('付款参数', data);
          axios.Customer('/public/order/createVoucher', data).then(res => {
            if (res.success) {
              that.voucherId = res.result.id;
              const data = {
                authCode: authCode || code,
                openId: this.openId,
                paymentTypeEnum: Platform.isWeiXin() ? 'WECHAT' : 'ALIPAY',
                voucherId: res.result.id,
                payBehavior: 'FRONT_SCAN',
                customerPay: true
              };
              let payTotal;
              if (!that.chooseCoupon.discountPrice) {
                payTotal = that.productTotal;
              } else {
                payTotal = that.productTotal - Number(that.chooseCoupon.discountPrice);
              }
              if (payTotal > 0) {
                if (Platform.isWeiXin()) {
                    if (window.location.href.indexOf('fromBrandMiniapp') != -1 || window.localStorage.getItem('fromBrandMiniapp')) {
                      let _authCode = data.authCode;
                      let _voucherId = data.voucherId;
                      let _paymentTypeEnum = data.paymentTypeEnum;
                      (this.objectId = randomString(32)),
                        window.wx.miniProgram.navigateTo({
                          url: `/pages/pay-h5/index?authCode=${_authCode}&voucherId=${_voucherId}&paymentTypeEnum=${_paymentTypeEnum}&from=XIAOMAI_WEISHANGCHENG&payLevel=one`, //小程序地址
                        });
                        return;
                    } else {
                      if(this.supportAssetsPay){
                        window.router.push({
                          name: 'account_pay',
                          query: {
                            instId: that.instId,
                            voucherId: this.voucherId,
                            bizModel: 'onlineStore',
                            authCode: authCode || code,
                            openId: this.openId,
                            appId: this.appid,
                            instName: that.inst.instName,
                          },
                        });
                        return
                      }
                    }
                }else if (Platform.isAlipay()) {
                    if(this.supportAssetsPay){
                        window.router.push({
                          name: 'account_pay',
                          query: {
                            instId: that.instId,
                            voucherId: this.voucherId,
                            bizModel: 'onlineStore',
                            authCode: authCode || code,
                            openId: this.openId,
                            appId: this.appid,
                            instName: that.inst.instName,
                          },
                        });
                        return
                    }
                }
                axios.Customer('/public/order/xmPrePay', data).then(res => {
                  if (!res.success) {
                    Vue.$wheatToast.loading('获取支付参数失败!');
                    return;
                  }
                  if (Platform.isWeiXin()) {
                    this.doWechatPay(res.result);
                  } else if (Platform.isAlipay()) {
                    res.result.prepayId = res.result.prePayId;
                    this.doAlipay(res);
                  }
                  // this.doWechatPay(res.result);
                });
              } else {
                window.router.replace({
                  name: 'online_pay_success',
                  query: {
                    instId: that.instId,
                    voucherId: that.voucherId,
                    instName: that.inst.instName,
                  },
                });
              }
            }
          })
          .finally(() => {
            Toast.clear();
          });
        }
      })
    },
    weixinJSBridgeInvoke(sign) {
      window.WeixinJSBridge.invoke('getBrandWCPayRequest', sign, res => {
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          this.payStatus = 4;
          window.router.replace({
            name: 'online_pay_success',
            query: {
              instId: this.instId,
              voucherId: this.voucherId,
              instName: this.inst.instName,
            },
          });
        } else {
          let path = window.location.origin + window.location.pathname;
          path = `${path}?voucherId=${this.voucherId}&needPay=true&instId=${this.instId}#/mine/voucher/detail`;
          // let url = location.href;
          const reloadUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${window.encodeURIComponent(
            path,
          )}&response_type=code&scope=snsapi_base#wechat_redirect`;
          window.localStorage.removeItem('pay_openId');
          window.location.href = reloadUrl;
        }
      });
    },
    doWechatPay(res) {
      const data = res;
      const getBrandWCPayRequest = {
        appId: data.appid || data.appId, //公众号名称，由商户传入
        timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
        nonceStr: data.nonceStr, //随机串
        package: 'prepay_id=' + (data.prepayId || data.prePayId),
        signType: data.signType || 'MD5', //微信签名方式:
        paySign: data.sign || data.paySign, //微信签名
      };
      if (window.WeixinJSBridge) {
        this.weixinJSBridgeInvoke(getBrandWCPayRequest);
      } else if (document.addEventListener) {
        document.addEventListener(
          'WeixinJSBridgeReady',
          () => {
            this.weixinJSBridgeInvoke(getBrandWCPayRequest);
          },
          false,
        );
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', () => {
          this.weixinJSBridgeInvoke(getBrandWCPayRequest);
        });
        document.attachEvent('onWeixinJSBridgeReady', () => {
          this.weixinJSBridgeInvoke(getBrandWCPayRequest);
        });
      }
    },
    doAlipay(res) {
      const data = res.data;
      AlipayJSBridge.call(
        'tradePay',
        {
          tradeNO: data.prepayId,
        },
        result => {
          if (result.resultCode === '9000') {
            this.payStatus = 4;
            window.router.replace({
              name: 'online_pay_success',
              query: {
                instId: this.instId,
                voucherId: this.voucherId,
                instName: this.inst.instName,
              },
            });
          } else {
            let path = window.location.origin + window.location.pathname;
            path = `${path}#/mine/voucher/detail?voucherId=${this.voucherId}&needPay=true&instId=${this.instId}`;
            // let url = location.href;
            const reloadUrl = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${
              this.appid
            }&scope=auth_base&redirect_uri=${window.encodeURIComponent(path)}`;

            window.localStorage.removeItem('pay_openId');
            window.location.href = reloadUrl;
          }
        },
      );
    },
    getBindAbleList() {
      axios
        .Customer(
          'public/groupToStudent/bindAbleListByUser',
          {
            instId: window.getParameterByName('instId'),
            platform: Platform.isAlipay() ? 'ALIYUN_H5' : 'WECHAT_GZH',
            appId: User.appId(),
          },
          {},
        )
        .then(res => {
          const { result = [] } = res;

          if (result.length) {
            this.$router.push({
              name: 'online_relevance',
              query: {
                studentList: JSON.stringify(result),
              },
            });
          } else {
            this.showAddStudent = true;
          }
        });
    },
    handleSuitItem(courseId, suiteIndex, classId) {
      this.courseId = courseId;
      Object.assign(this.selectedClass, {
        suiteIndex,
        classId,
      });
      this.handleShowClass();
    },

    handleShowClass() {
      this.showAddClass = true;
    },
    handleManagerClass() {
      this.showAddManager = true;
    },
    handleFollowerClass() {
      this.showAddFollower = true;
    },
    // 关闭【选择班级】弹窗
    closeAddClass() {
      this.showAddClass = false;
    },
    // 【选择班级】确认弹窗
    confirmAddClass(_selectedClass) {
      const { classId = '', className = '' } = _selectedClass;
      const { suiteIndex } = this.selectedClass;

      if (suiteIndex >= 0) {
        // 套餐里的选择班级
        const productData = JSON.parse(JSON.stringify(this.productData));

        Object.assign(productData.suiteDetails[suiteIndex], {
          className,
          classId,
        });
        this.productData = productData;
      } else {
        // 课程里的选择班级
        this.selectedClass = _selectedClass;
      }
    },

    closeAddManager() {
      this.selectedManagerId = 0;
      this.showAddManager = false;
    },
    closeAddFollower() {
      this.selectedFollowerId = 0;
      this.showAddFollower = false;
    },
    confirmAddManager(_selectedManagerId) {
      // this.selectedManager = _selectedManager;
      if (_selectedManagerId !== 0) {
        let arr = {};
        arr = this.managerList.find(item => {
          return item.id === _selectedManagerId;
        });
        this.selectedManagerId = _selectedManagerId;
        this.selectedManager = arr;
      } else {
        this.selectedManager = {};
      }
    },
    confirmAddFollower(_selectedFollower) {
      // this.selectedFollower = _selectedFollower;
      if (_selectedFollower !== 0) {
        let arr = {};
        arr = this.followerList.find(item => {
          return item.id === _selectedFollower;
        });
        this.selectedFollowerId = _selectedFollower;
        this.selectedFollower = arr;
      } else {
        this.selectedFollower = {};
      }
    },
    addStudent() {
      this.showAddStudent = true;
      // if (User.uid() && User.uid() != '0') {
      //   this.getBindAbleList();
      // } else {
      // }
    },
    fetchCouponLIst() {
      const { studentId } = this;

      if (!studentId) {
        return false;
      }

      const data = {
        specId: window.getParameterByName('specId'),
        instId: window.getParameterByName('instId'),
        studentId,
      };
      axios.Customer('public/coupon/getOnlineStoreStudentCouponList', data).then(res => {
        const validCouponList = res.result.validCouponList;
        this.invalidCouponList = res.result.invalidCouponList;
        this.validCouponList = validCouponList;
        if (validCouponList.length > 0) {
          this.chooseCoupon = res.result.validCouponList[0];
        } else {
          this.chooseCoupon = {};
        }
      });
    },
    handleShowChooseCoupon() {
      if (this.validCouponList.length + this.invalidCouponList.length > 0) {
        this.showChooseCoupon = true;
      }
    },
    handleHideChooseCoupon() {
      this.showChooseCoupon = false;
    },

    handleChooseCoupon(item) {
      this.chooseCoupon = item;
      this.handleHideChooseCoupon();
    },
    getAdviserList() {
      let data = {
        instId: this.instId,
        size: 100,
      };
      axios.Customer('public/admin/getAdminByName', data).then(res => {
        let adviserList = res.result.records;
        adviserList.map(item => {
          item.value = this.desensitizeName(item.adminName) + '(' + item.accountNo.slice(7, 11) + ')';
        });
        this.adviserList = adviserList;
        this.adviserSlots = [
          {
            values: this.adviserList,
            defaultIndex: 0,
          },
        ];
      });
    },
    // 更换顾问
    handleChangeAdviserSlotValues(picker, values) {
      this.adviserChooseValues = values[0];
    },

    // 确认选择顾问
    handleOkAdviserSelect() {
      this.currentAdviser = this.adviserChooseValues;
      this.adviserSlots[0].defaultIndex = this.adviserList.indexOf(this.currentInst) + 1;
      this.handleShowPopup('_follower_');
    },
    toggleSuite() {
      if (this.suiteShow) {
        this.suiteShow = false;
      } else {
        this.suiteShow = true;
      }
    },
    inputBlur() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
   desensitizeName(str) {
      if (null != str && str != undefined) {
        if (this.isEmojiCharacter(str)) {
          return str;
        } else {
          if (str.length <= 2) {
            return str.substring(0, 1) + '*';
          } else {
            return str.substring(0, 1) + '*' + str.substring(str.length - 1);
          }
        }
      }
    },
    hideAddStudentPop() {
      this.showAddStudent = false;
    },
    hideChooseCoupon() {
      this.showChooseCoupon = false;
    },
    wxMiNiProgramReady() {
      if (window.WeixinJSBridge) {
        this.listenWeixinVisible();
      } else if (document.addEventListener) {
        document.addEventListener(
          'WeixinJSBridgeReady',
          () => {
            this.listenWeixinVisible();
          },
          false,
        );
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', () => {
          this.listenWeixinVisible();
        });
        document.attachEvent('onWeixinJSBridgeReady', () => {
          this.listenWeixinVisible();
        });
      }
    },
    //  监听微信H5展示隐藏
    listenWeixinVisible() {
      window.WeixinJSBridge.on('onPageStateChange', (res = {}) => {
        if (res.active) {
          this.objectId = randomString(32);
        }
      });
    },
    // 获取商城配置
    fetchSettings() {
      const params = {
        instId: this.instId,
      };
      axios.Customer('public/mall/fetchPurchaseFormItemSettings', params).then(res => {
        console.log('商城配置', res.result.formItemSettings);
        this.settings = res.result.formItemSettings;
        this.fetchStudentAttributes();
      });
    },
    fetchStudentAttributes() {
      const params = {
        instId: this.instId,
      };
      return axios.Customer('public/institution/fetchStudentAttributes', params).then(res => {
        let arr = res.result.filter(item => {
          return this.showSettingsItem(item.attrId) === true;
        });
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].attrType === 'SINGLE_OPTION') {
            arr[i].optionId = 0;
            arr[i].optionName = '';
          } else if (arr[i].attrType === 'TEXT') {
            arr[i].attrText = '';
          }
        }
        this.studentAttributes = arr;
      });
    },
    fetchFollowerList() {
      let data = {
        instId: this.instId,
        commodityId: window.getParameterByName('commodityId'),
      };
      axios.Customer('public/mall/fetchCommodityFollowerList', data).then(res => {
        this.followerList = res.result;
      });
    },
    fetchManagerList() {
      let data = {
        instId: this.instId,
        commodityId: window.getParameterByName('commodityId'),
      };
      axios.Customer('public/mall/fetchCommodityManagerList', data).then(res => {
        this.managerList = res.result;
      });
    },
    // 获取年级列表
    getGradeList() {
      let id = this.instId;
      PayService.getGradeList(id).then(res => {
        let gradeList = res.data;
        gradeList.map(item => {
          item.value = item.name;
        });
        // 交换初中四年级和初中的位置
        for (let i = 0; i < gradeList.length; i++) {
          if (gradeList[i].code === '14' && gradeList[i + 1] && gradeList[i + 1].code === '15') {
            const data15 = gradeList[i + 1];
            gradeList[i + 1] = gradeList[i];
            gradeList[i] = data15;
          }
        }
        this.gradeList = gradeList;
        this.gradeSlots = [
          {
            values: this.gradeList,
            defaultIndex: 0,
          },
        ];
      });
    },
    // 显示/隐藏popup
    handleShowPopup(type) {
      switch (type) {
        case '_follower_':
          this.showAddFollower = !this.showAddFollower;
          break;
        case '_class_':
          this.showAddClass = !this.showAddClass;
          break;
        case '_gender_':
          this.showGenderPopup = !this.showGenderPopup;
          break;
        case '_grade_':
          this.showGradePopup = !this.showGradePopup;
          break;
        case '_birthday_':
          this.showDatePopup = !this.showDatePopup;
          break;
      }
    },
    openCustomPopup(item, index) {
      this.customIndex = index;
      console.log(item);
      let customList = item.optionVOList;
      customList.map(item => {
        item.id = item.attrId;
        item.value = item.optionName;
      });
      let k = item.optionVOList.findIndex(option => {
        return option.optionId === item.optionId;
      });
      this.customSlots = [
        {
          values: customList,
          defaultIndex: k === -1 ? 0 : k,
        },
      ];
      this.showCustomPopup = !this.showCustomPopup;
    },
    closeCustomPopup() {
      this.showCustomPopup = !this.showCustomPopup;
    },
    // 更换选择
    handleChangeSlotValues(picker, values, type) {
      switch (type) {
        case '_follower_':
          this.followerChooseValues.value = values[0];
          this.followerChooseValues.index = this.followerList.findIndex(item => {
            return item.id === values[0].id;
          });
          break;
        case '_gender_':
          this.genderChooseValues.value = values[0];
          if (values[0].name === 'MAN') this.genderChooseValues.index = 0;
          else this.genderChooseValues.index = 1;
          break;
        case '_grade_':
          this.gradeChooseValues.value = values[0];
          this.gradeChooseValues.index = this.gradeList.findIndex(item => {
            return item.code === values[0].code;
          });
          break;
        case '_custom_':
          this.customChooseValues = values[0];
          break;
      }
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      }
      if (type === 'month') {
        return `${val}月`;
      }
      if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    // 生日确认选择
    handleDateOkSelect(date) {
      this.dateChooseValues = date;
      this.currentDate = new Date(date).getTime();
      this.showDatePopup = !this.showDatePopup;
    },
    // 确认选择
    handleOkSelect(type) {
      switch (type) {
        case '_gender_':
          this.currentGender = this.genderChooseValues.value;
          this.genderSlots[0].defaultIndex = this.genderChooseValues.index;
          this.handleShowPopup('_gender_');
          break;
        case '_grade_':
          this.currentGrade = this.gradeChooseValues.value;
          this.gradeSlots[0].defaultIndex = this.gradeChooseValues.index;
          this.handleShowPopup('_grade_');
          break;
      }
    },
    handleOkCustomSelect() {
      this.studentAttributes[this.customIndex].optionId = this.customChooseValues.optionId;
      this.studentAttributes[this.customIndex].optionName = this.customChooseValues.optionName;
      this.showCustomPopup = !this.showCustomPopup;
    },
    showSettingsItem(type) {
      const k = this.settings.findIndex(item => {
        return item.key === type;
      });
      if (k !== -1 && this.settings[k].display) {
        return true;
      }
      return false;
    },
    requiredSettingsItem(type) {
      const k = this.settings.findIndex(item => {
        return item.key === type;
      });
      if (k === -1) {
        return false;
      } else {
        return this.settings[k].required;
      }
    },
    // 获取学员初始信息
    getStuInfo(id) {
      const params = {
        studentId: id,
      };
      axios.Customer('public/mall/fetchStudentFormData', params).then(res => {
        if (res.success) {
          console.log('学员信息', res.result);

          // 性别
          if (res.result.gender === 'MAN') {
            this.currentGender = { code: 1, name: 'MAN', value: '男' };
          } else if (res.result.gender === 'WOMEN') {
            this.currentGender = { code: 2, name: 'WOMEN', value: '女' };
          } else {
            this.currentGender = '';
          }
          // 年级
          if (res.result.grade !== -1) {
            this.currentGrade = this.gradeList.find(item => {
              return item.code === res.result.grade;
            });
          } else {
            this.currentGrade = {};
          }

          // 学校
          if (res.result.school !== '') {
            this.currentSchool = res.result.school;
          } else {
            this.currentSchool = '';
          }

          // 生日
          if (res.result.birthday) {
            this.currentDate = res.result.birthday;
            this.dateChooseValues = new Date(res.result.birthday);
          } else {
            this.currentDate = '';
            this.dateChooseValues = new Date(1640966400000);
          }

          // 自定义

          let _attributes = JSON.parse(JSON.stringify(res.result.attributes));
          console.log('获取自定义信息', this.studentAttributes, _attributes);
          for (let i = 0; i < this.studentAttributes.length; i++) {
            if (this.studentAttributes[i].attrType === 'TEXT') {
              let text = _attributes.find(item => {
                return item.attrId === this.studentAttributes[i].attrId;
              });
              this.studentAttributes[i].attrText = text.attrText;
            }
            if (this.studentAttributes[i].attrType === 'SINGLE_OPTION') {
              let text = _attributes.find(item => {
                return item.attrId === this.studentAttributes[i].attrId;
              });
              this.studentAttributes[i].optionId = text.optionId;
              this.studentAttributes[i].optionName = text.optionName;
            }
          }
        }
      });
    },
     isEmojiCharacter(substring) {
      for (var i = 0; i < substring.length; i++) {
        var hs = substring.charCodeAt(i);
        if (0xd800 <= hs && hs <= 0xdbff) {
          if (substring.length > 1) {
            var ls = substring.charCodeAt(i + 1);
            var uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
            if (0x1d000 <= uc && uc <= 0x1f77f) {
              return true;
            }
          }
        } else if (substring.length > 1) {
          var ls = substring.charCodeAt(i + 1);
          if (ls == 0x20e3) {
            return true;
          }
        } else {
          if (0x2100 <= hs && hs <= 0x27ff) {
            return true;
          } else if (0x2b05 <= hs && hs <= 0x2b07) {
            return true;
          } else if (0x2934 <= hs && hs <= 0x2935) {
            return true;
          } else if (0x3297 <= hs && hs <= 0x3299) {
            return true;
          } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030 || hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b || hs == 0x2b50) {
            return true;
          }
        }
      }
      return false;
    },
    checkSupportAssetsPay(){
      const data = {
        bizModel: 'onlineStore',
        instId: window.getParameterByName('instId'),
      };
      axios.Customer('anon/assets/checkSupportAssetsPay', data).then(res => {
        this.supportAssetsPay = res.result;
      });
    }
  },
};
</script>
<style lang="less" scoped>
@import '../../core/mixins.less';
.order-confirm-page {
  .order-confirm {
    padding-bottom: 1rem;
    .student {
      text-align: left;
      background: #fff;
      padding: 0.24rem 0.32rem 0.42rem;
      margin: 0.2rem 0;
      overflow: hidden;
      display: block;
      height: auto;
      padding-bottom: 0px;
      .title {
        margin-bottom: 0.2rem;
        line-height: 0.42rem;
        font-size: 0.3rem;
        color: #4a4a4a;
        font-weight: 700;
        width: 1rem;
        float: left;
        .tip {
          color: #ff4f4f;
          margin-right: 0.04rem;
        }
      }
      .box-list {
        float: left;
        clear: both;
        overflow: hidden;
        .item {
          padding: 0.08rem 0.16rem;
          border: 1px solid #ddd;
          border-radius: 0.1rem;
          width: 2.16rem;
          margin-bottom: 0.16rem;
          float: left;
          margin-right: 0.15rem;
          .name {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 0.3rem;
            color: #666666;
            line-height: 0.42rem;
            margin-bottom: 0.04rem;
          }
          .phone {
            font-size: 0.26rem;
            color: #666666;
            line-height: 0.36rem;
          }
          &:nth-child(3n + 0) {
            margin-right: 0;
          }
        }
        .active-item {
          background: rgba(255, 105, 52, 0.1);
          border: 1px solid rgba(255, 105, 52, 1);
          .name {
            color: rgba(255, 105, 52, 1);
          }
          .phone {
            color: rgba(255, 105, 52, 1);
            opacity: 0.5;
          }
        }
        .disable-item {
          .name {
            color: #999;
          }
          .phone {
            color: #999;
          }
        }
        .add-item {
          padding: 0.25rem 0.12rem;
          .add-img {
            width: 0.4rem;
            height: 0.4rem;
            vertical-align: middle;
          }
          .text {
            font-size: 0.3rem;
            color: #999999;
            line-height: 0.42rem;
            vertical-align: middle;
          }
        }
      }
    }
    .pro-info {
      background: #fff;
      margin-bottom: 0.2rem;
      .inst {
        display: flex;
        padding: 0 0.32rem;
        align-items: center;
        height: 0.8rem;
        border-bottom: 1px solid #eee;
        .icon {
          color: #999;
          font-size: 0.32rem;
          margin-right: 0.1rem;
          line-height: 0.8rem;
        }
        .word {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #333333;
          font-size: 0.26rem;
          max-width: ~'calc(100% - 0.48rem)';
          flex-shrink: 0;
        }
      }
      .box {
        padding: 0.28rem 0.32rem 0.32rem 0.32rem;
        display: flex;
        .pro-img {
          width: 1.56rem;
          height: 1.56rem;
          margin-right: 0.16rem;
          .img {
            display: inline-block;
            width: 1.56rem;
            height: 1.56rem;
            border-radius: 0.1rem;
          }
        }
        .detail {
          text-align: left;
          flex: 1;
          .detail-title {
            display: flex;
          }
          .name {
            text-align: left;
            font-size: 0.3rem;
            color: #4a4a4a;
            line-height: 0.42rem;
            word-break: break-all;
          }
          .tag {
            margin-left: 0.16rem;
            white-space: nowrap;
            .item {
              vertical-align: top;
              font-size: 0.22rem;
              color: #999999;
              border: 0.5px solid #dddddd;
              padding: 0 0.08rem;
              height: 0.32rem;
              line-height: 0.32rem;
              margin-left: 0.04rem;
              border-radius: 2px;
            }
          }
          .goods-sku {
            padding: 0.08rem 0.16rem;
            background: #f6f7f8;
            border-radius: 0.04rem;
            display: inline-block;
            line-height: 1;
            span {
              word-break: break-all;
              font-size: 0.26rem;
              color: #999999;
              line-height: 0.32rem;
            }
          }
          .price {
            text-align: left;
            margin-top: 0.08rem;
            .value {
              font-size: 0.3rem;
              color: #ff6934;
              line-height: 0.42rem;
            }
            .line-price {
              font-size: 0.22rem;
              color: #999999;
              line-height: 0.32rem;
              text-decoration: line-through;
            }
            .unit {
              font-size: 0.22rem;
              color: #999999;
              line-height: 0.32rem;
            }
          }
        }
      }
      .suite-label {
        text-align: left;
        padding-left: 0.32rem;
        font-size: 12px;
        color: #666;
      }
      .package {
        text-align: left;
        padding: 0 0.2rem;
        // margin:0 0.32rem;
        background: #fafafa;
        border: 1px solid #eee;
        margin: 0.16rem 0.32rem 0.22rem 0.32rem;
        border-radius: 0.1rem;
        .item {
          padding: 0.24rem 0;
          border-bottom: 1px dashed #eee;
          .name {
            font-size: 0.3rem;
            color: #333333;
            line-height: 0.42rem;
            margin-bottom: 0.08rem;
          }
          .standard {
            font-size: 0.26rem;
            color: rgba(153, 153, 153, 1);
            line-height: 0.36rem;
            span {
              font-size: 0.26rem;
            }
          }
          .card {
            font-size: 0.26rem;
            line-height: 0.36rem;
            color: #999999;
            margin-bottom: 0.08rem;
          }
          .buy {
            font-size: 0.26rem;
            line-height: 0.42rem;
            color: #333333;
            margin-bottom: 0.08rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              font-size: 0.26rem;
            }
          }
          .send {
            font-size: 0.26rem;
            line-height: 0.42rem;
            color: #333333;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              font-size: 0.26rem;
            }
          }
          .select-class {
            font-size: 0.26rem;
            line-height: 0.42rem;
            color: #333333;
            display: flex;
            justify-content: space-between;
            align-items: center;
                    .tip {
          color: #ff4f4f;
          margin-right: 0.04rem;
        }
            span {
              font-size: 0.26rem;
              &.gray {
                color: #cccccc;
              }
              &.selected_class_name {
                text-align: right;
                margin-left: 0.6rem;
                vertical-align: bottom;
                .text-overflow-ellipsis();
                width: 2rem;
              }
            }
          }
          &:last-child {
            border-bottom: 0px;
          }
        }
      }
      .total {
        text-align: right;
        padding: 0 0.32rem 0.16rem 0.32rem;
        .num {
          color: #999999;
          font-size: 0.3rem;
          line-height: 0.42rem;
        }
        .value {
          color: #ff6934;
          font-size: 0.3rem;
          line-height: 0.42rem;
          margin-left: 0.08rem;
        }
      }
    }
    .coupon-content {
      height: 0.92rem;
      padding: 0 0.3rem;
      background: #fff;
      margin-bottom: 0.01rem;
      .coupon-content-inner {
        .divide-bottom();
        .divide-top();
        width: 100%;
        height: 0.92rem;
        line-height: 0.92rem;
        display: flex;
        .icon {
          color: #ccc;
        }
        .coupon-content-name {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          &.gray {
            color: #ccc;
          }
          &.blue {
            color: #3296fa;
          }
          .coupon-content-name-title {
            overflow: hidden;
            max-width: 3rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
          }
        }
      }
    }
    .cell-content {
      height: 0.88rem;
      padding: 0 0.3rem;
      background: #fff;
      margin-bottom: 0.02rem;
      .cell-content-inner {
        width: 100%;
        height: 0.88rem;
        line-height: 0.88rem;
        display: flex;
        justify-content: space-between;
        .cell-content-text {
          color: #333333;
          font-size: 0.3rem;
          .tip {
            color: #ff4f4f;
            margin-right: 0.04rem;
          }
        }
        .icon {
          color: #ccc;
        }
        .cell-content-name {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          text-align: right;
          margin-left: 0.6rem;
          .text-overflow-ellipsis();
          &.gray {
            color: #ccc;
          }
        }
      }
    }
    .setting-item {
      height: 0.88rem;
      padding: 0 0.3rem;
      background: #fff;
      margin-bottom: 0.02rem;
      .content-inner {
        height: 0.88rem;
        line-height: 0.88rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .item-right {
        color: #ccc;
        display: flex;
        align-items: center;
        .icon {
          color: #ccc;
        }
        .select {
          color: #333333;
        }
      }
      .tip {
        color: #ff4f4f;
        margin-right: 0.04rem;
      }
      .cell-content-inner {
        .cell-content-text {
          color: #333333;
          font-size: 0.3rem;
          .tip {
            color: #ff4f4f;
            margin-right: 0.04rem;
          }
        }
        .icon {
          color: #ccc;
        }
        .cell-content-name {
          margin-left: 0.6rem;
          .text-overflow-ellipsis();
          &.gray {
            color: #ccc;
          }
        }
      }
    }
    .description {
      background: #fff;
      text-align: left;
      padding: 0 0.3rem;
      margin-bottom: 1.1rem;
      .label {
        padding: 0.24rem 0 0.2rem;
        font-size: 0.3rem;
        color: #333333;
        line-height: 0.42rem;
        border-bottom: 0.5px solid #eee;
        .tip {
          color: #ff4f4f;
          margin-right: 0.04rem;
        }
      }
      textarea {
        padding: 0.24rem 0;
        border: none;
        width: 100%;
        height: 1.5rem;
      }
      textarea::-webkit-input-placeholder {
        color: #ccc;
      }
    }
  }
  .footer {
    position: fixed;
    display: flex;
    // justify-content: space-between;
    bottom: 0;
    left: 0;
    height: 0.88rem;
    width: 100%;
    background: #fff;
    .text {
      border-top: 1px solid #eee;
      height: 0.88rem;
      line-height: 0.88rem;
      padding-left: 0.32rem;
      width: calc(100% - 2.4rem);
      text-align: left;
      .text-left {
        font-size: 0.3rem;
        color: #ff6934;
        line-height: 0.42rem;
        margin-right: 0.08rem;
      }
      .text-right {
        color: #999999;
        font-size: 0.26rem;
        text-decoration: line-through;
      }
    }
    .submit {
      width: 3.5rem;
      height: 0.88rem;
      background-image: linear-gradient(to right, #ff7819, #ff4200);
      color: #fff;
      text-align: center;
      line-height: 0.88rem;
      font-size: 0.3rem;
      border: none;
    }
  }
  .toolbar {
    height: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.4rem;
    .divide-bottom();
    .toolbar-cancle,
    .toolbar-ok {
      color: #3296fa;
    }
  }
  .coupon-popup {
    border-radius: 0.2rem 0.2rem 0 0;
  }
  .student-popup {
    border-radius: 0.2rem 0.2rem 0 0;
  }
  .manager-popup{
    border-radius: 0.2rem 0.2rem 0 0;
     .yd-popup {
      border-top-left-radius: 0.2rem;
      border-top-right-radius: 0.2rem;
       overflow: hidden;
       .yd-popup-content {
        height: 100%;
      }
    }
  }
  .follower-popup {
    border-radius: 0.2rem 0.2rem 0 0;
    .yd-popup {
      border-top-left-radius: 0.2rem;
      border-top-right-radius: 0.2rem;
       overflow: hidden;
       .yd-popup-content {
        height: 100%;
      }
    }
  }
  .yd-search {
            .yd-search-input {
              background: #ffffff;
              .search-input {
                background: #f7f7f7;
              }
            }
            .-text {
              color: #999;
            }
          }
}
</style>
}
</style>



// WEBPACK FOOTER //
// src/module/mall/OrderConfirmV5.vue